import "./browserPatches";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes } from "react-router-dom";
import { WagmiConfig } from "wagmi";
import { RoundProvider } from "./context/RoundContext";
import { initDatadog } from "./datadog";
import { initSentry } from "./sentry";
import { initTagmanager } from "./tagmanager";
import { chains, config } from "./app/wagmi";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

// Routes
import AccessDenied from "./features/common/AccessDenied";
import Auth from "./features/common/Auth";
import NotFound from "./features/common/NotFoundPage";
import ApplyNowPage from "./features/discovery/ApplyNowPage";
import LandingPage from "./features/discovery/LandingPage";
import ViewProjectDetails from "./features/round/ViewProjectDetails";
import { ChakraProvider } from "@chakra-ui/react";
import ViewApplicationDetails from "./features/round/ViewApplicationDetails";
import ScrollToHashElement from "./features/common/ScrollToHashElement";

// Initialize sentry
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
initSentry();

// Initialize datadog
initDatadog();

// Initialize tagmanager
initTagmanager();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render( /*#__PURE__*/_jsx(React.StrictMode, {
  children: /*#__PURE__*/_jsx(ChakraProvider, {
    children: /*#__PURE__*/_jsx(WagmiConfig, {
      config: config,
      children: /*#__PURE__*/_jsx(RainbowKitProvider, {
        coolMode: true,
        chains: chains,
        children: /*#__PURE__*/_jsx(RoundProvider, {
          children: /*#__PURE__*/_jsxs(HashRouter, {
            children: [/*#__PURE__*/_jsx(ScrollToHashElement, {}), /*#__PURE__*/_jsxs(Routes, {
              children: [/*#__PURE__*/_jsx(Route, {
                element: /*#__PURE__*/_jsx(Auth, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "/",
                element: /*#__PURE__*/_jsx(LandingPage, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "/apply-now",
                element: /*#__PURE__*/_jsx(ApplyNowPage, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "/round/:chainId/:roundId/:applicationId",
                element: /*#__PURE__*/_jsx(ViewApplicationDetails, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "/round/:chainId/:roundId/:applicationId/registry/:registryAddress/project/:id",
                element: /*#__PURE__*/_jsx(ViewProjectDetails, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "/access-denied",
                element: /*#__PURE__*/_jsx(AccessDenied, {})
              }), /*#__PURE__*/_jsx(Route, {
                path: "*",
                element: /*#__PURE__*/_jsx(NotFound, {})
              })]
            })]
          })
        })
      })
    })
  })
}));
reportWebVitals();